import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M48,25.41c-0.62,10.66-8.2,19.62-18.61,22L15.7,34.18l0.71-0.9l1.48-0.64l0,0l1.34-2.69l2.68-5.44l0.59-1.19
	l2.46-5l0,0l0.59-1.18l0.08-0.17V16.9l1.51-2.9l0.14-0.28L29.11,10l1.83,1.5l0,0L48,25.41z"
  />
);

const HollyAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_2}
    renderShadow={renderShadow}
  >
    <>
      <circle style={{ fill: '#F7DEBC' }} cx="24" cy="26" r="9" />
      <path
        style={{
          fill: '#8E6947',
          stroke: '#825E43',
          strokeWidth: 0.5,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
        }}
        d="M32,16.29l-0.05-0.04c-0.01,0.01-0.01,0.02-0.03,0.03c0,0.06-0.03,0.12-0.09,0.16
	c-0.11,0.08-0.27,0.05-0.35-0.06c-1.46-2.39-5.77-2.56-8.23-2.25c-1.59,0.21-3.13,0.69-4.56,1.43c-1.02,0.66-2.09,1.22-3.22,1.66
	c-0.09,0.02-0.18,0-0.24-0.07c-0.94-0.97-0.6-3.54-0.42-4.72c0.2-1.59,0.77-3.1,1.66-4.43c0.77-1.16,1.9-2.03,3.22-2.49
	c0.65-0.2,1.32-0.27,2-0.23c0.67,0.12,1.35,0.07,2-0.12c0.24-0.13,0.5-0.25,0.76-0.34c1.26-0.31,2.22,0.55,2.93,1.46
	c0.5,0.6,0.9,1.27,1.18,2c0.07,0.35,0.19,0.69,0.36,1c0.3,0.29,0.63,0.53,1,0.72C31.89,11.39,33.14,14.02,32,16.29z"
      />
      <path
        style={{ fill: '#8E6947' }}
        d="M31.81,15.98c-0.02,0.06-0.05,0.12-0.08,0.18l-0.01,0.11c-0.06-0.1-0.12-0.2-0.2-0.3
	c0.05-0.08,0.08-0.16,0.11-0.24C31.69,15.81,31.75,15.89,31.81,15.98z"
      />
      <path
        style={{ fill: '#8E6947' }}
        d="M31.92,16.28c-0.15,0.24-0.54-0.01-0.41-0.28c0.01-0.01,0.01-0.02,0.01-0.03c0.05-0.08,0.08-0.16,0.11-0.24
	c0.06,0.08,0.12,0.16,0.18,0.25c0.04,0.05,0.07,0.1,0.1,0.15C31.93,16.18,31.94,16.23,31.92,16.28z"
      />
      <path
        style={{ fill: '#F7DEBC' }}
        d="M33,27.3c0.46-1.09,1.14-2.07,2-2.88c0.07-0.06,0.16-0.13,0.24-0.08c0.05,0.04,0.08,0.09,0.09,0.15
	c0.22,1.08,0.15,2.2-0.2,3.24l-0.43,1.76c-0.12,0.57-0.29,1.13-0.52,1.67c-0.12,0.31-0.33,0.58-0.6,0.76
	c-0.28,0.16-0.64,0.09-0.83-0.18c-0.08-0.17-0.12-0.35-0.13-0.53C32.36,29.8,32.49,28.34,33,27"
      />
      <path
        style={{ fill: '#333333' }}
        d="M32.56,24.79c0.12,0.33,0.08,0.7-0.09,1c-0.12,0.1-0.26,0.2-0.4,0.27c-0.67,0.45-0.64,1.52-1,2.3
	C30.51,29.37,29.45,30,28.29,30c-0.3,0.05-0.6,0.02-0.88-0.1c-0.61-0.29-1.1-0.76-1.41-1.36c-0.28-0.81-0.65-1.24-0.92-2.05
	c-0.03-0.33-0.03-0.67,0-1c0-0.34,0.68-0.65,0.9-0.88c0.52-0.47,1.16-0.77,1.85-0.86c0.55-0.14,1.11-0.21,1.67-0.2
	c1.06,0.12,2.08,0.46,3,1"
      />
      <path
        style={{ fill: '#333333' }}
        d="M22.72,25.26c0.62,0.71,1.7,0.79,2.41,0.17c0.06-0.05,0.12-0.11,0.17-0.17c0.26,0.67,0.41,1.37,0.44,2.09
	c-1.02-0.75-2.42-0.72-3.41,0.06c0,0-0.06,0.05-0.09,0s0,0,0-0.06c-0.12-0.38-0.08-0.79,0.11-1.14c0.19-0.34,0.33-0.71,0.43-1.09"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M25.57,14.76c0.76-0.92,1.12-2.1,1-3.28c0.03-0.27-0.02-0.53-0.15-0.77c-0.19-0.27-0.52-0.41-0.85-0.37
	c-0.33,0.04-0.64,0.17-0.91,0.36c-0.17-1.03-1.15-1.72-2.18-1.55c-1.03,0.17-1.72,1.15-1.55,2.18c-0.53-0.34-1.24-0.18-1.57,0.35
	c-0.11,0.18-0.17,0.39-0.18,0.6c0.06,0.49,0.27,0.96,0.61,1.32c0.35,0.55,0.84,0.99,1.43,1.27c0.25,0.08,0.52,0.12,0.78,0.13
	c0.61,0.07,1.22,0.11,1.83,0.11c0.57,0.05,1.15-0.09,1.64-0.39"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M25.75,14.94c1.26-1.37,1.89-6.28-1.17-4.45l0.36,0.15c-0.31-1.15-1.5-1.82-2.64-1.5
	c-0.98,0.27-1.64,1.18-1.58,2.19l0.38-0.22c-0.64-0.38-1.47-0.19-1.89,0.42c-0.49,0.76-0.07,1.55,0.41,2.2
	c0.52,0.85,1.39,1.41,2.38,1.53c1.18,0.3,2.42,0.2,3.54-0.26c0.11-0.08,0.14-0.24,0.06-0.35c-0.07-0.1-0.2-0.13-0.31-0.08
	c-1.03,0.43-2.18,0.51-3.26,0.24c-0.64-0.07-1.24-0.38-1.65-0.88c-0.2-0.22-0.38-0.46-0.55-0.71c-0.65-0.76-0.31-1.3,1-1.62
	c0.13,0.07,0.28,0.02,0.35-0.11c0.02-0.03,0.03-0.07,0.03-0.11c-0.08-0.91,0.59-1.71,1.5-1.79c0.8-0.07,1.53,0.45,1.74,1.23
	c0.04,0.14,0.19,0.21,0.33,0.17c0.01,0,0.03-0.01,0.04-0.02c0.38-0.23,1.32,0.17,1.53,0.56c0.12,0.21,0,0.82-0.07,1
	c-0.07,0.77-0.38,1.49-0.89,2.07C25.17,14.83,25.52,15.19,25.75,14.94L25.75,14.94z"
      />
      <path
        style={{
          fill: '#8E6947',
          stroke: '#825E43',
          strokeWidth: 0.5,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
        }}
        d="M33,27l-0.25-0.65c0.14-1.54-0.22-3.06-1.02-4.36c-0.01,0.02-0.03,0.02-0.05,0.03
	c-0.92,0.4-1.85,0.77-2.79,1.11c-0.14-0.48-0.39-0.91-0.73-1.28c-0.4,0.6-0.93,1.1-1.55,1.46c-0.47-2.23-1-4.57-2.6-6.29
	C21.27,17.44,18.77,18.85,17,21c-0.13,0.09-0.26,0.18-0.4,0.27C15.69,23.06,15.15,25,15,27c-0.78-1.41-1-3.06-0.6-4.6
	c-0.27,0.19-0.49,0.45-0.66,0.75c-0.86-2.21-0.33-4.71,1.33-6.39c1.66-1.64,3.81-2.69,6.13-3c2.41-0.4,4.87-0.32,7.25,0.24
	c1.12,0.21,2.18,0.65,3.13,1.28c0.95,0.66,1.58,1.69,1.74,2.83c0.08,0.71-0.11,1.4-0.52,1.95c0.19,0.22,0.5,0.4,0.73,0.61
	c0.37,0.39,0.56,0.9,0.55,1.43C34.27,23.81,33.89,25.53,33,27z"
      />
      <path
        style={{ fill: '#F7DEBC' }}
        d="M33.2,27.43c0.21-0.48,0.46-0.95,0.74-1.4c0.27-0.4,0.88-1.68,1.24-0.75s-0.38,2.58-0.6,3.48
	c-0.12,0.51-0.22,1-0.38,1.52c-0.1,0.37-0.25,0.72-0.43,1.06c-0.73,0.2-1.05,0-1-0.53c-0.28-1.26-0.13-2.57,0.41-3.74
	c0.13-0.29-0.3-0.54-0.44-0.25c-0.38,0.88-0.57,1.82-0.54,2.78c0,0.62-0.11,1.77,0.28,2.29c1.18,1.53,2.17-1.46,2.34-2.12
	c0.31-1.07,0.56-2.16,0.75-3.26c0.06-0.39,0.31-2-0.22-2.35c-1-0.56-2.36,2.47-2.61,3c-0.13,0.29,0.3,0.55,0.43,0.26L33.2,27.43z"
      />
      <circle style={{ fill: '#FFFFFF' }} cx="34" cy="32" r="1" />
      <path
        style={{ fill: '#F7DEBC' }}
        d="M15.18,27.27c-0.49-1-1.21-1.86-2.1-2.53c-0.09-0.09-0.21-0.14-0.34-0.14c-0.2,0-0.3,0.24-0.35,0.43
	c-0.29,1.07-0.29,2.21,0,3.28c0.31,1.06,0.76,2.07,1.34,3c0.1,0.24,0.29,0.42,0.54,0.5c0.22,0.02,0.43-0.09,0.55-0.28
	c0.11-0.19,0.18-0.4,0.21-0.62c0.19-0.96,0.32-1.93,0.4-2.91c0-0.37,0-0.83-0.3-1"
      />
      <path
        style={{ fill: '#F7DEBC' }}
        d="M15.4,27.14c-0.37-0.68-2-3.53-3-2.59c-0.5,0.46-0.43,1.74-0.4,2.33c0.07,1.01,0.33,2,0.75,2.92
	c0.28,0.65,1.34,3.32,2.37,1.87c0.36-0.84,0.52-1.76,0.47-2.67c0.07-0.76,0.32-1.66-0.29-2.25c-0.1-0.1-0.26-0.09-0.36,0.01
	c-0.1,0.1-0.09,0.26,0.01,0.35c0.53,0.5,0.19,2.66,0,3.3c0,0.53-0.27,0.78-0.92,0.76c-0.1-0.18-0.21-0.36-0.3-0.54
	c-0.31-0.52-0.57-1.07-0.8-1.63c-0.14-0.39-0.26-0.79-0.34-1.19c-0.1-0.46-0.36-1.91-0.06-2.34c0.81-1.13,2.15,1.35,2.44,1.89
	c0.15,0.29,0.58,0,0.43-0.25V27.14z"
      />
      <circle style={{ fill: '#FFFFFF' }} cx="14" cy="32" r="1" />
      <path
        style={{ fill: '#F7DEBC' }}
        d="M23.72,39.26c-1.33,0-6.93-3.2-8.28-5.3C15,33.28,15,26.81,15,26.81l9-4.18l9,4.18c0,0,0.13,6.35-0.44,7.15
	C31.11,36.02,25.33,39.26,23.72,39.26z"
      />
      <g>
        <g>
          <path
            style={{ fill: '#333333' }}
            d="M32.8,24.72c0-0.07-0.1-0.32-0.2-0.37c-2-1-4.54-1.62-6.57-0.16c-0.48,0.34-0.86,0.6-1.07,0.99
			c-0.53,0.43-1.29,0.45-1.84,0.04c-0.2-0.44-0.61-0.7-1.12-1.04c-2.15-1.43-4.63-0.89-6.77,0.16C15.12,24.39,15,24.72,15,24.72
			c-0.21,1.35,0.76,1.25,1.15,2.42c0.31,0.94,0.41,1.73,1.26,2.35c1.38,1.15,3.44,0.96,4.59-0.42c0.11-0.13,0.2-0.27,0.29-0.41
			c0.29-0.41,0.52-0.86,0.68-1.33c0.28-0.13,0.56-0.24,0.85-0.33c0.42-0.03,0.83,0.03,1.21,0.19c0.18,0.57,0.44,1.11,0.77,1.61
			c0.93,1.46,2.87,1.88,4.32,0.95c0.13-0.08,0.24-0.17,0.35-0.26c0.67-0.62,1.1-1.45,1.23-2.35C32.06,25.98,33.01,26.05,32.8,24.72z
			"
          />
        </g>
      </g>
      <path
        style={{ fill: '#E2987D' }}
        d="M26,35.12h-4.56c-0.14,0-0.15-0.33,0-0.5c0.4-0.45,1.07-0.69,1.64-0.92c0.26-0.02,0.51,0.08,0.77,0.1
	c0.36,0,0.41-0.22,0.89,0c0.48,0.22,0.83,0.42,1.26,0.75C26.21,34.71,26.23,35.12,26,35.12z"
      />
      <path
        style={{ fill: '#EDAA96' }}
        d="M26.11,35.12c-0.59,0.57-1.46,0.86-2.34,0.77c-0.44,0.02-0.88-0.03-1.3-0.14c-0.4-0.13-1.13-0.44-1.13-0.75
	c0-0.13,0.14-0.24,0.22-0.27c1.05-0.34,2.97-0.19,4.43,0C26.21,34.76,26.22,35,26.11,35.12z"
      />
    </>
  </AvatarArtwork>
);

export default HollyAvatarArtwork;
